import styled from 'styled-components'
import { breackpoints, cores } from '../../styles'

export const ButtonMenu = styled.button`
  display: none;
  background-color: transparent;
  border: none;
  color: ${cores.branco};

  @media (max-width: ${breackpoints.desktop}) {
    display: block;
  }
`
export const CardMenu = styled.div`
  display: none;
  justify-content: end;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  &.is-visible {
    display: flex;
  }
`

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-color: ${cores.preto};
  opacity: 0.7;
`

export const Menu = styled.aside`
  z-index: 1;
  max-width: 360px;
  width: 100%;
  padding: 20px;
  background-color: ${cores.azul};

  & > div {
    display: flex;
    justify-content: end;

    button {
      background-color: transparent;
      border: none;
      color: ${cores.branco};
      font-size: 25px;
      font-weight: bold;
    }
  }
`
export const Links = styled.ul`
  margin-bottom: 25px;

  button {
    padding: 9px 16px;
    background-color: transparent;
    border: 1px solid ${cores.branco};
    border-radius: 36px;
    color: ${cores.branco};
  }

  li {
    margin: 15px 0;
    a {
      color: ${cores.branco};
      opacity: 0.8;

      &:hover {
        opacity: 1;
      }
    }
  }
`
